import { render, staticRenderFns } from "./custom-200.vue?vue&type=template&id=c6fd2fc4&"
import script from "./custom-200.vue?vue&type=script&lang=js&"
export * from "./custom-200.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports